import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import Breadcrumb from '../../../shared/components/Breadcrumb';

const ResultLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f5f5f7]">
      <Header />
      <div className="w-full max-w-[1600px] mx-auto px-4 pt-4">
        <Breadcrumb />
      </div>
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default ResultLayout;
